import { useSearchParams } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  Receipt,
  CreditCard,
  CalendarDays,
  CalendarX2,
  Coins,
  UserCheck,
  ShoppingBag,
  Package,
  School,
} from "lucide-react";
import "./AdminPage.scss";
import Seo from "../../components/Seo/Seo";
import {
  UsersSection,
  KreditySection,
  OsobySection,
  SchoolsSection,
  KatalogProduktovSection,
  OrdersSection,
  CancellationsSection,
} from "./sections";

export const ADMIN_MENU_ITEMS = [
  { key: "orders", label: "Správa objednávok", icon: Package },
  { key: "cancellations", label: "Zrušené lekcie", icon: CalendarX2 },
  { key: "users", label: "Správa užívateľov", icon: Users },
  { key: "schools", label: "Základné školy", icon: School },
  { key: "osoby", label: "Osoby", icon: UserCheck },
  { key: "kredity", label: "Kredity", icon: Coins },
  { key: "katalog", label: "Katalóg krúžkov", icon: ShoppingBag },
];

function AdminPage() {
  const [searchParams] = useSearchParams();
  const activeSection = searchParams.get("tab") || "orders";

  const activeItem =
    ADMIN_MENU_ITEMS.find((item) => item.key === activeSection) ||
    ADMIN_MENU_ITEMS[0];
  const ActiveIcon = activeItem.icon;

  const renderContent = () => {
    switch (activeSection) {
      case "orders":
        return <OrdersSection />;
      case "cancellations":
        return <CancellationsSection />;
      case "users":
        return <UsersSection />;
      case "schools":
        return <SchoolsSection />;
      case "osoby":
        return <OsobySection />;
      case "kredity":
        return <KreditySection />;
      case "katalog":
        return <KatalogProduktovSection />;
      default:
        return <OrdersSection />;
    }
  };

  return (
    <div className="admin">
      <Seo title={`Admin – ${activeItem.label}`} noIndex={true} />

      <main className="admin__content">
        <div className="admin__header-bar">
          <div className="admin__header-title-group">
            <div className="admin__header-icon-wrap">
              <ActiveIcon size={22} />
            </div>
            <div>
              <span className="admin__header-badge">Admin Panel</span>
              <h1 className="admin__header-title">{activeItem.label}</h1>
            </div>
          </div>
        </div>

        <div className="admin__body">{renderContent()}</div>
      </main>
    </div>
  );
}

export default AdminPage;
